import React from "react";
import { ScaleLoader } from "react-spinners"

import Box from "../Box";
import Flex from "../Flex";

export const Loader = () => {
  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      zIndex="9999"    
      animation="fadeIn 0.5s;"       
    >
      <Flex 
        width="100%"
        height="100%"        
        alignItems="center"
        justifyContent="center"  
        backgroundColor="rgba(0, 0, 0, 0.75)"      
      >
        <ScaleLoader
          color={"#fff"}
          size={50}
        />        
      </Flex>
    </Box>
    )
}